export const enum SignInState {
  NOT_SIGNED_IN,
  VALIDATE_SIGN_IN_STATUS,
  SIGNIN_LINK_REQUESTED,
  // A still-valid magic link was detected but not consumed (deferred
  // consumption): renders MagicLinkContinue and waits for the customer to
  // press the action before anything is sent to the proxy.
  MAGIC_LINK_PENDING,
  SIGNING_YOU_IN,
  SIGNED_IN,
}

export const enum SignInMethodUsed {
  MAGIC_LINK,
  FIDO,
}
